import React from "react";
import { Column } from "react-table";
import { CaptionProp, col } from "../../../@types/react-table";
import { useTableConfig, useTranslate } from "../../../helpers";
import { RenderedTable } from "../../../components/Tables";

/**
 * SubSectionTable is a table in the Overview section that has only two columns: the heading and the value.
 * @param data specifies the data to be displayed in the table
 * @param caption specifies the section table caption
 * @returns React function component
 */
export const SubSectionTable: React.FunctionComponent<{
  data: {
    label: string | JSX.Element;
    value: unknown;
  }[];
  caption: CaptionProp;
}> = ({ data, caption }) => {
  const cols: Array<Column<col>> = [
    {
      accessor: "label", // accessor is the "key" in the data
    },
    {
      accessor: "value",
    },
  ];

  const t = useTranslate();

  return (
    <div>
      <RenderedTable
        className="two-column-table"
        tableColumns={useTableConfig(cols)}
        tableData={React.useMemo(() => data, [t])}
        rowHeaders // Indicates the first column should be rendered as `th scope="row"`
        borderless // is a default for Plan Details, TBD if it should be baked in
        stackableBreakpoint="lg" // is a default for Plan Details, TBD if it should be baked in
        caption={caption}
      />
    </div>
  );
};
